var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-textarea',_vm._b({staticClass:"blw-control blw-textarea",on:{"input":function($event){return _vm.$emit('input', $event)}}},'v-textarea',{ ..._vm.$props, ..._vm.$attrs },false))
}
var staticRenderFns = []

export { render, staticRenderFns }